import React from "react";

function DiscordLink() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#5865F2"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#fff"
        d="M18.63 7.148a14.269 14.269 0 00-3.527-1.094.052.052 0 00-.056.027c-.152.27-.321.625-.439.902-1.332-.2-2.657-.2-3.962 0a9.19 9.19 0 00-.446-.902.056.056 0 00-.057-.027 14.28 14.28 0 00-3.527 1.094.054.054 0 00-.024.02c-2.246 3.358-2.862 6.633-2.56 9.868.002.016.01.03.023.04a14.367 14.367 0 004.328 2.189.056.056 0 00.06-.02c.333-.456.63-.936.885-1.441a.055.055 0 00-.03-.077 9.543 9.543 0 01-1.352-.644.056.056 0 01-.006-.093c.091-.068.182-.138.268-.21a.053.053 0 01.057-.008c2.836 1.296 5.907 1.296 8.71 0a.053.053 0 01.055.007c.087.072.178.143.27.211a.056.056 0 01-.005.093c-.432.252-.88.466-1.353.644a.055.055 0 00-.03.078c.26.503.558.983.885 1.44.013.019.038.027.06.02a14.32 14.32 0 004.335-2.188.057.057 0 00.023-.04c.361-3.74-.606-6.987-2.563-9.867a.046.046 0 00-.022-.021v-.001zm-8.88 7.918c-.854 0-1.557-.784-1.557-1.747 0-.963.69-1.747 1.558-1.747.867 0 1.571.792 1.557 1.747 0 .963-.69 1.747-1.557 1.747zm5.76 0c-.855 0-1.558-.784-1.558-1.747 0-.963.69-1.747 1.557-1.747s1.572.792 1.558 1.747c0 .963-.683 1.747-1.558 1.747z"
      ></path>
    </svg>
  );
}

export default DiscordLink;
